"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _modalContext = require("@zipwhip/zipkit/dist/context/modal-context");

var _constants = require("../../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InfoModal = function InfoModal(_ref) {
  var content = _ref.content,
      openerText = _ref.openerText;
  return (
    /*#__PURE__*/
    _react.default.createElement(_modalContext.ModalConsumer, null, function (_ref2) {
      var showModalComponent = _ref2.showModalComponent;
      return (
        /*#__PURE__*/
        _react.default.createElement("span", {
          className: "".concat(_constants.STYLE_BASE, "_fieldModalHelperOpener"),
          onClick: function onClick() {
            showModalComponent(
            /*#__PURE__*/
            _react.default.createElement("div", {
              className: "zw-default-div-style ".concat(_constants.STYLE_BASE, "_fieldModalHelper")
            }, content));
          }
        }, openerText)
      );
    })
  );
};

var _default = InfoModal;
exports.default = _default;